import { __decorate, __param } from '../../../../../../../external/tslib/tslib.es6.js';
import { Emitter } from 'monaco-editor/esm/vs/base/common/event.js';
import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
import { Disposable, toDisposable } from 'monaco-editor/esm/vs/base/common/lifecycle.js';
import { IEditorService } from '../../editor/common/editorService.js';
const IWorkingCopyEditorService = ( createDecorator('workingCopyEditorService'));
let WorkingCopyEditorService = class WorkingCopyEditorService extends Disposable {
    constructor(editorService) {
        super();
        this.editorService = editorService;
        this._onDidRegisterHandler = this._register(( new Emitter()));
        this.onDidRegisterHandler = this._onDidRegisterHandler.event;
        this.handlers = ( new Set());
    }
    registerHandler(handler) {
        this.handlers.add(handler);
        this._onDidRegisterHandler.fire(handler);
        return toDisposable(() => this.handlers.delete(handler));
    }
    findEditor(workingCopy) {
        for (const editorIdentifier of this.editorService.getEditors(0 )) {
            if (this.isOpen(workingCopy, editorIdentifier.editor)) {
                return editorIdentifier;
            }
        }
        return undefined;
    }
    isOpen(workingCopy, editor) {
        for (const handler of this.handlers) {
            if (handler.isOpen(workingCopy, editor)) {
                return true;
            }
        }
        return false;
    }
};
WorkingCopyEditorService = ( __decorate([
    ( __param(0, IEditorService))
], WorkingCopyEditorService));
export { IWorkingCopyEditorService, WorkingCopyEditorService };
